import { getUserCognitoGroups } from './auth-groups.util';
import { isCommercialInsurerUser, UserGroup } from './get-group';

/**
 * Acesso à Gestão Financeira (Meus Recibos + Demonstrativo de Comissão), conforme
 * as stories 974/Demonstrativo: Seguradora com perfil Administrador ou Comercial,
 * ou qualquer perfil de Assessoria, ou qualquer perfil de Corretor. Bloqueia
 * Seguradora Subscritor (underwriter) e CX/Atendimento (customer_support).
 */
export async function requireFinancialAccess(): Promise<boolean> {
  const groups = await getUserCognitoGroups();

  const isAdvisoryOrBroker = groups.some(
    group => group.startsWith('advisory.') || group.startsWith('broker.')
  );
  const isInsurerAdminOrCommercial =
    groups.includes(UserGroup.INSURER_ADMINISTRATOR) ||
    isCommercialInsurerUser(groups);

  return isAdvisoryOrBroker || isInsurerAdminOrCommercial;
}
